import { NgModule } from '@angular/core';
import { SafePipe } from './safe.pipe';
import { SpinnerComponent } from "./spinnercomponent/spinner.component";

export const components = [
  SpinnerComponent,
  SafePipe
];

@NgModule({
  declarations: [components],
  providers: [
  ],
  imports: [
  ],
  exports: [components],

})
export class ComponentsModule { }
